// @CoreModules
import { useState } from 'react';
// Contexts
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { useStylesContextConsumerHook } from 'contexts/styles.context';
// Event Handlers
import { LayoutFooterHandlers } from 'components/layout/components/footer/handlers/layout-footer.handlers';
// Types
import { LayoutFooterHookType } from './types/layout-footer.hook.type';
import { LayoutFooterTrackingHandlers } from '../handlers/layout-footer.tracking.handlers';

const useLayoutFooterHook = (): LayoutFooterHookType => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const {
      mainButtonConfiguration: buttonConfiguration,
      buttonGhostConfiguration: linkConfiguration,
    } = useLayoutContextConsumerHook(),
    { fetching } = useFetchErrorContextConsumerHook(),
    { paddingContent } = useStylesContextConsumerHook();

  const {
    handleCancelApplicationLinkClickTracking,
    handleCloseCancelApplicationModalClickTracking,
  } = useAppTrackingHook(LayoutFooterTrackingHandlers);

  return {
    ...LayoutFooterHandlers({
      handleCancelApplicationLinkClickTracking,
      handleCloseCancelApplicationModalClickTracking,
      setShowModal,
    }),
    buttonConfiguration,
    linkConfiguration,
    fetching,
    paddingContent,
    showModal,
  };
};

export { useLayoutFooterHook };
